import React from 'react';
import classnames from 'classnames';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import Tab from './Tab';
export var Tabs = function (_a) {
    var width = _a.width, className = _a.className, s = _a.viewClassNames, items = _a.items, activeIndex = _a.activeIndex, extraTabs = _a.extraTabs, onChange = _a.onChange, activeItemRef = _a.activeItemRef, _b = _a.rootTag, RootTag = _b === void 0 ? 'div' : _b, a11yHeading = _a.a11yHeading;
    return (React.createElement(RootTag, { className: classnames(s['root'], className), style: { width: width } },
        a11yHeading && (React.createElement(VisuallyHidden, null,
            React.createElement(Heading, null, a11yHeading))),
        items.map(function (item) { return (React.createElement(Tab, { key: item.index, viewClassNames: s, label: React.createElement(React.Fragment, null,
                item.label,
                item.labelExtras), href: item.href, prefix: item.prefix, postfix: item.tabExtras, biData: item.biData, isActive: item.index === activeIndex, "data-hook": item.dataHook, onClick: onChange && (function () { return onChange(item.index); }), innerRef: item.index === activeIndex ? activeItemRef : undefined })); }),
        extraTabs));
};
Tabs.displayName = 'Tabs';
export default Tabs;
//# sourceMappingURL=Tabs.js.map